/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Permissioncount1Inputs */

const en_entity_permissioncount1 = /** @type {(inputs: Entity_Permissioncount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission Count`)
};

const de_entity_permissioncount1 = /** @type {(inputs: Entity_Permissioncount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungsanzahl`)
};

/**
* | output |
* | --- |
* | "Permission Count" |
*
* @param {Entity_Permissioncount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_permissioncount1 = /** @type {((inputs?: Entity_Permissioncount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Permissioncount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_permissioncount1(inputs)
	return de_entity_permissioncount1(inputs)
});
export { entity_permissioncount1 as "entity_permissionCount" }